import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Youtube, Linkedin, Music } from 'lucide-react';

const platforms = [
  { name: 'Instagram', handle: '@forrealrutviii', href: 'https://www.instagram.com/forrealrutviii', Icon: Instagram },
  { name: 'YouTube', handle: '@forrealrutvii', href: 'https://youtube.com/@forrealrutvii', Icon: Youtube },
  { name: 'TikTok', handle: '@forrealrutvii', href: 'https://www.tiktok.com/@forrealrutvii', Icon: Music },
  { name: 'LinkedIn', handle: 'Rutvi Ahir', href: 'https://www.linkedin.com/', Icon: Linkedin },
];

const PlatformBadges = () => {
  return (
    <section
      data-testid="platform-badges"
      className="py-14 sm:py-20 px-6 sm:px-8 lg:px-12 bg-[#F4F4F3] border-b border-[#1C1917]/10"
    >
      <div className="max-w-7xl mx-auto">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#78716C] text-center mb-10">
          Where HypeLab shows up
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
          {platforms.map((p, i) => (
            <motion.a
              key={p.name}
              href={p.href}
              target="_blank"
              rel="noreferrer"
              data-testid={`platform-${p.name.toLowerCase()}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              whileHover={{ y: -4 }}
              className="group bg-white border border-[#1C1917]/10 rounded-2xl p-6 flex flex-col items-start gap-3 hover:border-[#AA94FF] transition-colors"
            >
              <p.Icon className="w-8 h-8 text-[#1C1917] group-hover:text-[#AA94FF] transition-colors" />
              <div>
                <p
                  className="text-lg font-bold text-[#1C1917]"
                  style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
                >
                  {p.name}
                </p>
                <p className="text-xs text-[#78716C] truncate">{p.handle}</p>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlatformBadges;
